import { render, staticRenderFns } from "./VCheckboxWithValidation.vue?vue&type=template&id=653a7fa4&scoped=true"
import script from "./VCheckboxWithValidation.vue?vue&type=script&lang=js"
export * from "./VCheckboxWithValidation.vue?vue&type=script&lang=js"
import style0 from "./VCheckboxWithValidation.vue?vue&type=style&index=0&id=653a7fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a7fa4",
  null
  
)

export default component.exports